import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';

@Component({
    selector: 'print-files',
    templateUrl: './print-files.component.html',
    styleUrls: ['./print-files.component.scss'],
    standalone: false
})
export class PrintFilesComponent {
  printFiles: any[] = [];
  copiedFileName?: string;
  copiedUrl?: string;
  allCopied?: boolean;
  allUrlCopied?: boolean;
  searchText: string = '';
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals) {

  }

  async ngOnInit() {
    this.printFiles = await this.api.store().get<any>(`/print-files/latest`);

  }

  copySKU(fileName: string) {
    this.copiedFileName = fileName;
    this.allCopied = false;
    navigator.clipboard.writeText(fileName.split('.')[0]);
  }

  copyAllSKU() {
    delete this.copiedFileName;
    this.allCopied = true;
    navigator.clipboard.writeText(this.printFiles.map(p => `${p.fileName.split('.')[0]}`).join('\r\n'));
  }


  copyURL(url: string) {
    this.copiedUrl = url;
    this.allCopied = false;
    navigator.clipboard.writeText(url);
  }

  copyAllURL() {
    delete this.copiedUrl;
    this.allUrlCopied = true;
    navigator.clipboard.writeText(this.printFiles.map(p => `${p.url}`).join('\r\n'));
  }

  async search() {
    this.allCopied = false;
    this.printFiles = await this.api.store().get<any>(`/print-files/search?q=${this.searchText}`);
  }



}


